import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

import { useHasManualEdits } from './ManualEditsLegendContext';
import { LegendRoot, LegendSwatch } from './ManualEditsLegend.style';

export const MANUAL_EDIT_LEGEND_LABEL = 'Manually Added';

export const ManualEditsLegend = () => {
    const theme = useInterstateTheme();
    const hasManualEdits = useHasManualEdits();

    if (!hasManualEdits) return null;

    return (
        <LegendRoot theme={theme} data-testid="manual-edits-legend">
            <LegendSwatch theme={theme} aria-hidden />
            {MANUAL_EDIT_LEGEND_LABEL}
        </LegendRoot>
    );
};
